export const LOGOUT = 'LOGOUT'
export const SAVE_TOKEN = 'SAVE_TOKEN'
export const FETCH_USER = 'FETCH_USER'
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE'
export const UPDATE_USER = 'UPDATE_USER'
export const RUN_CALCULATIONS = 'RUN_CALCULATIONS'
export const CHECK_FOR_DAILY = 'CHECK_FOR_DAILY'

export const GET_WEEKLY_BLOG_START = 'GET_WEEKLY_BLOG_START'
export const GET_WEEKLY_BLOG_SUCCESS = 'GET_WEEKLY_BLOG_SUCCESS'
export const GET_WEEKLY_BLOG_ERROR = 'GET_WEEKLY_BLOG_ERROR'

export const GET_CONTRACTORS_START = 'GET_CONTRACTORS_START'
export const GET_CONTRACTORS_SUCCESS = 'GET_CONTRACTORS_SUCCESS'
export const GET_CONTRACTORS_ERROR = 'GET_CONTRACTORS_ERROR'

export const GET_INSPECTORS_START = 'GET_INSPECTORS_START'
export const GET_INSPECTORS_SUCCESS = 'GET_INSPECTORS_SUCCESS'
export const GET_INSPECTORS_ERROR = 'GET_INSPECTORS_ERROR'

export const GET_NEW_ASSIGNMENT_SUCCESS = 'GET_NEW_ASSIGNMENT_SUCCESS'
export const GET_NEW_ASSIGNMENT_ERROR = 'GET_NEW_ASSIGNMENT_ERROR'

export const SET_UPDATE_STATUS = 'SET_UPDATE_STATUS'
export const SET_UPDATE_ROOM_STATUS = 'SET_UPDATE_ROOM_STATUS'

export const GET_CONTRACTS_START = 'GET_CONTRACTS_START'
export const GET_CONTRACTS_SUCCESS = 'GET_CONTRACTS_SUCCESS'
export const GET_CONTRACTS_ERROR = 'GET_CONTRACTS_ERROR'

export const CHECK_ROLES = 'CHECK_ROLES'

export const GET_TYPE_PAYMENTS_START = 'GET_TYPE_PAYMENTS_START'
export const GET_TYPE_PAYMENTS_SUCCESS = 'GET_TYPE_PAYMENTS_SUCCESS'
export const GET_TYPE_PAYMENTS_ERROR = 'GET_TYPE_PAYMENTS_ERROR'

export const GET_PERIODS_START = 'GET_PERIODS_START'
export const GET_PERIODS_SUCCESS = 'GET_PERIODS_SUCCESS'
export const GET_PERIODS_ERROR = 'GET_PERIODS_ERROR'

export const GET_CONTRACTING_START = 'GET_CONTRACTING_START'
export const GET_CONTRACTING_SUCCESS = 'GET_CONTRACTING_SUCCESS'
export const GET_CONTRACTING_ERROR = 'GET_CONTRACTING_ERROR'

export const GET_HOUSES_START = 'GET_HOUSES_START'
export const GET_HOUSES_SUCCESS = 'GET_HOUSES_SUCCESS'
export const GET_HOUSES_ERROR = 'GET_HOUSES_ERROR'

export const DELETE_MODEL = 'DELETE_MODEL'

export const CHANGE_VALUE_INPUT = 'CHANGE_VALUE_INPUT'

export const GET_CONTRACT_FOR_HOUSING_AND_PROJECT_ID_START = 'GET_CONTRACT_FOR_HOUSING_AND_PROJECT_ID_START'
export const GET_CONTRACT_FOR_HOUSING_AND_PROJECT_ID_SUCCESS = 'GET_CONTRACT_FOR_HOUSING_AND_PROJECT_ID_SUCCESS'
export const GET_CONTRACT_FOR_HOUSING_AND_PROJECT_ID_ERROR = 'GET_CONTRACT_FOR_HOUSING_AND_PROJECT_ID_ERROR'

export const GET_CONTRACT_FOR_PROJECT_ID_START = 'GET_CONTRACT_FOR_PROJECT_ID_START'
export const GET_CONTRACT_FOR_PROJECT_ID_SUCCESS = 'GET_CONTRACT_FOR_PROJECT_ID_SUCCESS'
export const GET_CONTRACT_FOR_PROJECT_ID_ERROR = 'GET_CONTRACT_FOR_PROJECT_ID_ERROR'

export const SELECTION_CHANGE_SELECT2 = 'SELECTION_CHANGE_SELECT2'

export const GET_PROJECT_START = 'GET_PROJECT_START'
export const GET_PROJECT_SUCCESS = 'GET_PROJECT_SUCCESS'
export const GET_PROJECT_ERROR = 'GET_PROJECT_ERROR'

export const GET_PROJECT_HOUSES_START = 'GET_PROJECT_HOUSES_START'
export const GET_PROJECT_HOUSES_SUCCESS = 'GET_PROJECT_HOUSES_SUCCESS'
export const GET_PROJECT_HOUSES_ERROR = 'GET_PROJECT_HOUSES_ERROR'

export const GET_LOTES_START = 'GET_LOTES_START'
export const GET_LOTES_SUCCESS = 'GET_LOTES_SUCCESS'
export const GET_LOTES_ERROR = 'GET_LOTES_ERROR'

export const GET_LOTES_SELECTION_START = 'GET_LOTES_SELECTION_START'
export const GET_LOTES_SELECTION_SUCCESS = 'GET_LOTES_SELECTION_SUCCESS'
export const GET_LOTES_SELECTION_ERROR = 'GET_LOTES_SELECTION_ERROR'

export const GET_LOTES_SELECTION_ALL_START = 'GET_LOTES_SELECTION_ALL_START'
export const GET_LOTES_SELECTION_ALL_SUCCESS = 'GET_LOTES_SELECTION_ALL_SUCCESS'
export const GET_LOTES_SELECTION_ALL_ERROR = 'GET_LOTES_SELECTION_ALL_ERROR'

export const GET_DAY_MONTH = 'GET_DAY_MONTH'
export const GET_DAY_MONTH_CURRENT_YEAR = 'GET_DAY_MONTH_CURRENT_YEAR'
export const GET_DAYS_OF_THE_MONTH = 'GET_DAYS_OF_THE_MONTH'
export const GET_MAJOR_DATE = 'GET_MAJOR_DATE'

export const GET_FLAT_DETAILDS_START = 'GET_FLAT_DETAILDS_START'
export const GET_FLAT_DETAILDS_SUCCESS = 'GET_FLAT_DETAILDS_SUCCESS'
export const GET_FLAT_DETAILDS_ERROR = 'GET_FLAT_DETAILDS_ERROR'

export const GET_BLUEPRINTS_START = 'GET_BLUEPRINTS_START'
export const GET_BLUEPRINTS_SUCCESS = 'GET_BLUEPRINTS_SUCCESS'
export const GET_BLUEPRINTS_ERROR = 'GET_BLUEPRINTS_ERROR'

export const GET_TIME_DETAIL_START = 'GET_TIME_DETAIL_START'
export const GET_TIME_DETAIL_SUCCESS = 'GET_TIME_DETAIL_SUCCESS'
export const GET_TIME_DETAIL_ERROR = 'GET_TIME_DETAIL_ERROR'

export const GET_MATERIAL_STATE_START = 'GET_MATERIAL_STATE_START'
export const GET_MATERIAL_STATE_SUCCESS = 'GET_MATERIAL_STATE_SUCCESS'
export const GET_MATERIAL_STATE_ERROR = 'GET_MATERIAL_STATE_ERROR'

export const GET_ACTION_PLAN_START = 'GET_ACTION_PLAN_START'
export const GET_ACTION_PLAN_SUCCESS = 'GET_ACTION_PLAN_SUCCESS'
export const GET_ACTION_PLAN_ERROR = 'GET_ACTION_PLAN_ERROR'

export const GET_JIMP_START = 'GET_JIMP_START'
export const GET_JIMP_SUCCESS = 'GET_JIMP_SUCCESS'
export const GET_JIMP_ERROR = 'GET_JIMP_ERROR'

export const GET_JIMP_RECORDS_START = 'GET_JIMP_RECORDS_START'
export const GET_JIMP_RECORDS = 'GET_JIMP_RECORDS'

export const GET_PROGRAMMING_START = 'GET_PROGRAMMING_START'
export const GET_PROGRAMMING_SUCCESS = 'GET_PROGRAMMING_SUCCESS'
export const GET_PROGRAMMING_ERROR = 'GET_PROGRAMMING_ERROR'

export const GET_FILES_START = 'GET_FILES_START'
export const GET_FILES_SUCCESS = 'GET_FILES_SUCCESS'
export const GET_FILES_ERROR = 'GET_FILES_ERROR'

export const GET_PRIORITIES_START = 'GET_PRIORITIES_START'
export const GET_PRIORITIES_SUCCESS = 'GET_PRIORITIES_SUCCESS'
export const GET_PRIORITIES_ERROR = 'GET_PRIORITIES_ERROR'

export const GET_CHECK_SCHEDULE_START = 'GET_CHECK_SCHEDULE_START'
export const GET_CHECK_SCHEDULE_SUCCESS = 'GET_CHECK_SCHEDULE_SUCCESS'
export const GET_CHECK_SCHEDULE_ERROR = 'GET_CHECK_SCHEDULE_ERROR'

export const GET_TYPE_CONTRACT_START = 'GET_TYPE_CONTRACT_START'
export const GET_TYPE_CONTRACT_SUCCESS = 'GET_TYPE_CONTRACT_SUCCESS'
export const GET_TYPE_CONTRACT_ERROR = 'GET_TYPE_CONTRACT_ERROR'

export const GET_ACTIVITIES_BY_HOUSE_ID_START = 'GET_ACTIVITIES_BY_HOUSE_ID_START'
export const GET_ACTIVITIES_BY_HOUSE_ID_SUCCESS = 'GET_ACTIVITIES_BY_HOUSE_ID_SUCCESS'
export const GET_ACTIVITIES_BY_HOUSE_ID_ERROR = 'GET_ACTIVITIES_BY_HOUSE_ID_ERROR'

export const GET_LIST_HOUSES_BY_CONTRACT_START = 'GET_LIST_HOUSES_BY_CONTRACT_START'
export const GET_LIST_HOUSES_BY_CONTRACT_SUCCESS = 'GET_LIST_HOUSES_BY_CONTRACT_SUCCESS'
export const GET_LIST_HOUSES_BY_CONTRACT_ERROR = 'GET_LIST_HOUSES_BY_CONTRACT_ERROR'

export const GET_HOUSES_BY_CONTRACT_START = 'GET_HOUSES_BY_CONTRACT_START'
export const GET_HOUSES_BY_CONTRACT_SUCCESS = 'GET_HOUSES_BY_CONTRACT_SUCCESS'
export const GET_HOUSES_BY_CONTRACT_ERROR = 'GET_HOUSES_BY_CONTRACT_ERROR'

export const GET_HOUSES_CONTRACTS_START = 'GET_HOUSES_CONTRACTS_START'
export const GET_HOUSES_CONTRACTS_SUCCESS = 'GET_HOUSES_CONTRACTS_SUCCESS'
export const GET_HOUSES_CONTRACTS_ERROR = 'GET_HOUSES_CONTRACTS_ERROR'

export const GET_CONTRACT_START = 'GET_CONTRACT_START'
export const GET_CONTRACT_SUCCESS = 'GET_CONTRACT_SUCCESS'
export const GET_CONTRACT_ERROR = 'GET_CONTRACT_ERROR'

export const GET_HOUSE_DIARIES_START = 'GET_HOUSE_DIARIES_START'
export const GET_HOUSE_DIARIES_SUCCESS = 'GET_HOUSE_DIARIES_SUCCESS'
export const GET_HOUSE_DIARIES_ERROR = 'GET_HOUSE_DIARIES_ERROR'

export const GET_CONTRACT_INFRA_START = 'GET_CONTRACT_INFRA_START'
export const GET_CONTRACT_INFRA_SUCCESS = 'GET_CONTRACT_INFRA_SUCCESS'
export const GET_CONTRACT_INFRA_ERROR = 'GET_CONTRACT_INFRA_ERROR'

export const INDICATE_ROUTE_CHANGE = 'INDICATE_ROUTE_CHANGE'

export const TOTAL_GLOBAL_INVOICES = 'TOTAL_GLOBAL_INVOICES'

export const TOTAL_GLOBAL_CHECKS = 'TOTAL_GLOBAL_CHECKS'

export const GET_TIPE_OF_ACCOUNTING_ACCOUNTS_START = 'GET_TIPE_OF_ACCOUNTING_ACCOUNTS_START'
export const GET_TIPE_OF_ACCOUNTING_ACCOUNTS_SUCCESS = 'GET_TIPE_OF_ACCOUNTING_ACCOUNTS_SUCCESS'
export const GET_TIPE_OF_ACCOUNTING_ACCOUNTS_ERROR = 'GET_TIPE_OF_ACCOUNTING_ACCOUNTS_ERROR'

export const GET_ACCOUNTING_ACCOUNTS_START = 'GET_ACCOUNTING_ACCOUNTS_START'
export const GET_ACCOUNTING_ACCOUNTS_SUCCESS = 'GET_ACCOUNTING_ACCOUNTS_SUCCESS'
export const GET_ACCOUNTING_ACCOUNTS_ERROR = 'GET_ACCOUNTING_ACCOUNTS_ERROR'

export const GET_LIST_ROLES_START = 'GET_LIST_ROLES_START'
export const GET_LIST_ROLES_SUCCESS = 'GET_LIST_ROLES_SUCCESS'
export const GET_LIST_ROLES_ERROR = 'GET_LIST_ROLES_ERROR'

export const GET_TYPE_LIST_USERS_START = 'GET_TYPE_LIST_USERS_START'
export const GET_TYPE_LIST_USERS_SUCCESS = 'GET_TYPE_LIST_USERS_SUCCESS'
export const GET_TYPE_LIST_USERS_ERROR = 'GET_TYPE_LIST_USERS_ERROR'

export const GET_LIST_MODULES_START = 'GET_LIST_MODULES_START'
export const GET_LIST_MODULES_SUCCESS = 'GET_LIST_MODULES_SUCCESS'
export const GET_LIST_MODULES_ERROR = 'GET_LIST_MODULES_ERROR'

export const GET_LIST_OPTION_MENU_START = 'GET_LIST_OPTION_MENU_START'
export const GET_LIST_OPTION_MENU_SUCCESS = 'GET_LIST_OPTION_MENU_SUCCESS'
export const GET_LIST_OPTION_MENU_ERROR = 'GET_LIST_OPTION_MENU_ERROR'

export const GET_LIST_PERMISSION_START = 'GET_LIST_PERMISSION_START'
export const GET_LIST_PERMISSION_SUCCESS = 'GET_LIST_PERMISSION_SUCCESS'
export const GET_LIST_PERMISSION_ERROR = 'GET_LIST_PERMISSION_ERROR'

export const GET_LIST_ORGANIZATIONAL_ROLE_TYPE_START = 'GET_LIST_ORGANIZATIONAL_ROLE_TYPE_START'
export const GET_LIST_ORGANIZATIONAL_ROLE_TYPE_SUCCESS = 'GET_LIST_ORGANIZATIONAL_ROLE_TYPE_SUCCESS'
export const GET_LIST_ORGANIZATIONAL_ROLE_TYPE_ERROR = 'GET_LIST_ORGANIZATIONAL_ROLE_TYPE_ERROR'

export const EVENT_FIRE_WITH_GLOBAL_TOTAL_START = 'EVENT_FIRE_WITH_GLOBAL_TOTAL_START'
export const EVENT_FIRE_WITH_GLOBAL_TOTAL_SUCCESS = 'EVENT_FIRE_WITH_GLOBAL_TOTAL_SUCCESS'
export const EVENT_FIRE_WITH_GLOBAL_TOTAL_ERROR = 'EVENT_FIRE_WITH_GLOBAL_TOTAL_ERROR'

export const EVENT_STATUS_UPDATE_START = 'EVENT_STATUS_UPDATE_START'
export const EVENT_STATUS_UPDATE_SUCCESS = 'EVENT_STATUS_UPDATE_SUCCESS'
export const EVENT_STATUS_UPDATE_ERROR = 'EVENT_STATUS_UPDATE_ERROR'

export const GET_USERS_START = 'GET_USERS_START'
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS'
export const GET_USERS_ERROR = 'GET_USERS_ERROR'

export const GET_BANK_ACCOUNT_TYPES_START = 'GET_BANK_ACCOUNT_TYPES_START'
export const GET_BANK_ACCOUNT_TYPES_SUCCESS = 'GET_BANK_ACCOUNT_TYPES_SUCCESS'
export const GET_BANK_ACCOUNT_TYPES_ERROR = 'GET_BANK_ACCOUNT_TYPES_ERROR'

export const GET_BANK_ACCOUNT_TYPE_ACCOUNTS_START = 'GET_BANK_ACCOUNT_TYPE_ACCOUNTS_START'
export const GET_BANK_ACCOUNT_TYPE_ACCOUNTS_SUCCESS = 'GET_BANK_ACCOUNT_TYPE_ACCOUNTS_SUCCESS'
export const GET_BANK_ACCOUNT_TYPE_ACCOUNTS_ERROR = 'GET_BANK_ACCOUNT_TYPE_ACCOUNTS_ERROR'

export const GET_BANK_TYPES_START = 'GET_BANK_TYPES_START'
export const GET_BANK_TYPES_SUCCESS = 'GET_BANK_TYPES_SUCCESS'
export const GET_BANK_TYPES_ERROR = 'GET_BANK_TYPES_ERROR'

export const GET_BANK_ACCOUNTS_START = 'GET_BANK_ACCOUNTS_START'
export const GET_BANK_ACCOUNTS_SUCCESS = 'GET_BANK_ACCOUNTS_SUCCESS'
export const GET_BANK_ACCOUNTS_ERROR = 'GET_BANK_ACCOUNTS_ERROR'

export const GET_BANK_PAYMENT_TYPES_START = 'GET_BANK_PAYMENT_TYPES_START'
export const GET_BANK_PAYMENT_TYPES_SUCCESS = 'GET_BANK_PAYMENT_TYPES_SUCCESS'
export const GET_BANK_PAYMENT_TYPES_ERROR = 'GET_BANK_PAYMENT_TYPES_ERROR'

export const GET_PROJECT_BANK_ACCOUNTS_START = 'GET_PROJECT_BANK_ACCOUNTS_START'
export const GET_PROJECT_BANK_ACCOUNTS_SUCCESS = 'GET_PROJECT_BANK_ACCOUNTS_SUCCESS'
export const GET_PROJECT_BANK_ACCOUNTS_ERROR = 'GET_PROJECT_BANK_ACCOUNTS_ERROR'

export const SET_UPDATE_TOTAL_AMOUNT_PAY_JOBS_START = 'SET_UPDATE_TOTAL_AMOUNT_PAY_JOBS_START'
export const SET_UPDATE_TOTAL_AMOUNT_PAY_JOBS_SUCCESS = 'SET_UPDATE_TOTAL_AMOUNT_PAY_JOBS_SUCCESS'
export const SET_UPDATE_TOTAL_AMOUNT_PAY_JOBS_ERROR = 'SET_UPDATE_TOTAL_AMOUNT_PAY_JOBS_ERROR'

export const GET_JOBS_STATES_LIST_START = 'GET_JOBS_STATES_LIST_START'
export const GET_JOBS_STATES_LIST_SUCCESS = 'GET_JOBS_STATES_LIST_SUCCESS'
export const GET_JOBS_STATES_LIST_ERROR = 'GET_JOBS_STATES_LIST_ERROR'

export const GET_PAYMENT_TYPE_MODULES_START = 'GET_PAYMENT_TYPE_MODULES_START'
export const GET_PAYMENT_TYPE_MODULES_SUCCESS = 'GET_PAYMENT_TYPE_MODULES_SUCCESS'
export const GET_PAYMENT_TYPE_MODULES_ERROR = 'GET_PAYMENT_TYPE_MODULES_ERROR'

export const SET_EMIT_SHOW_ROW_DETAIL = 'SET_EMIT_SHOW_ROW_DETAIL'

export const GLOBAL_CHARGE_START = 'GLOBAL_CHARGE_START'
export const GLOBAL_CHARGE_SUCCESS = 'GLOBAL_CHARGE_SUCCESS'

export const GET_LOTS_BY_PRECONTRACT_START = 'GET_LOTS_BY_PRECONTRACT_START'
export const GET_LOTS_BY_PRECONTRACT_SUCCESS = 'GET_LOTS_BY_PRECONTRACT_SUCCESS'
export const GET_LOTS_BY_PRECONTRACT_ERROR = 'GET_LOTS_BY_PRECONTRACT_ERROR'

export const GET_SALES_PROJECT_MODELS_START = 'GET_SALES_PROJECT_MODELS_START'
export const GET_SALES_PROJECT_MODELS_SUCCESS = 'GET_SALES_PROJECT_MODELS_SUCCESS'
export const GET_SALES_PROJECT_MODELS_ERROR = 'GET_SALES_PROJECT_MODELS_ERROR'

export const GET_SALES_DOCUMENT_STATUS_START = 'GET_SALES_DOCUMENT_STATUS_START'
export const GET_SALES_DOCUMENT_STATUS_SUCCESS = 'GET_SALES_DOCUMENT_STATUS_SUCCESS'
export const GET_SALES_DOCUMENT_STATUS_ERROR = 'GET_SALES_DOCUMENT_STATUS_ERROR'

export const GET_SALES_STATES_PRECONTRACT_START = 'GET_SALES_STATES_PRECONTRACT_START'
export const GET_SALES_STATES_PRECONTRACT_SUCCESS = 'GET_SALES_STATES_PRECONTRACT_SUCCESS'
export const GET_SALES_STATES_PRECONTRACT_ERROR = 'GET_SALES_STATES_PRECONTRACT_ERROR'

export const GET_SALES_STATES_CARD_START = 'GET_SALES_STATES_CARD_START'
export const GET_SALES_STATES_CARD_SUCCESS = 'GET_SALES_STATES_CARD_SUCCESS'
export const GET_SALES_STATES_CARD_ERROR = 'GET_SALES_STATES_CARD_ERROR'

export const GET_SALES_BANK_APPLICATION_STATUS_START = 'GET_SALES_BANK_APPLICATION_STATUS_START'
export const GET_SALES_BANK_APPLICATION_STATUS_SUCCESS = 'GET_SALES_BANK_APPLICATION_STATUS_SUCCESS'
export const GET_SALES_BANK_APPLICATION_STATUS_ERROR = 'GET_SALES_BANK_APPLICATION_STATUS_ERROR'

export const GET_BATCH_TYPE_START = 'GET_BATCH_TYPE_START'
export const GET_BATCH_TYPE_SUCCESS = 'GET_BATCH_TYPE_SUCCESS'
export const GET_BATCH_TYPE_ERROR = 'GET_BATCH_TYPE_ERROR'

export const SET_GLOBAL_CHECK_ACTION = 'SET_GLOBAL_CHECK_ACTION'

export const GET_SALES_PROCESSORS_START = 'GET_SALES_PROCESSORS_START'
export const GET_SALES_PROCESSORS_SUCCESS = 'GET_SALES_PROCESSORS_SUCCESS'
export const GET_SALES_PROCESSORS_ERROR = 'GET_SALES_PROCESSORS_ERROR'

export const ASSIGN_SELECTION_DATE_START = 'ASSIGN_SELECTION_DATE_START'
export const ASSIGN_SELECTION_DATE_SUCCESS = 'ASSIGN_SELECTION_DATE_SUCCESS'
export const ASSIGN_SELECTION_DATE_ERROR = 'ASSIGN_SELECTION_DATE_ERROR'

export const PUSH_MESSAGE_START = 'PUSH_MESSAGE_START'
export const PUSH_MESSAGE_SUCCESS = 'PUSH_MESSAGE_SUCCESS'
export const PUSH_MESSAGE_ERROR = 'PUSH_MESSAGE_ERROR'

export const APPOINTMENT_ENTIRE_FORM = 'APPOINTMENT_ENTIRE_FORM'

export const GET_DATES_START = 'GET_DATES_START'
export const GET_DATES_SUCCESS = 'GET_DATES_SUCCESS'
export const GET_DATES_ERROR = 'GET_DATES_ERROR'

export const SET_DATE_APPOINTMENT = 'SET_DATE_APPOINTMENT'

export const GET_TIMES_START = 'GET_TIMES_START'
export const GET_TIMES_SUCCESS = 'GET_TIMES_SUCCESS'
export const GET_TIMES_ERROR = 'GET_TIMES_ERROR'

export const SET_APPOINTMENT_TIME = 'SET_APPOINTMENT_TIME'

export const EVENT_PUSHER_REQUEST_START = 'EVENT_PUSHER_REQUEST_START'
export const EVENT_PUSHER_REQUEST_SUCCESS = 'EVENT_PUSHER_REQUEST_SUCCESS'
export const EVENT_PUSHER_REQUEST_ERROR = 'EVENT_PUSHER_REQUEST_ERROR'
export const EVENT_PUSHER_REQUEST_SENT = 'EVENT_PUSHER_REQUEST_SENT'

export const GET_APPOINTMENT_STATUS_START = 'GET_APPOINTMENT_STATUS_START'
export const GET_APPOINTMENT_STATUS_SUCCESS = 'GET_APPOINTMENT_STATUS_SUCCESS'
export const GET_APPOINTMENT_STATUS_ERROR = 'GET_APPOINTMENT_STATUS_ERROR'

export const GET_USER_START = 'GET_USER_START'
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS'
export const GET_USER_ERROR = 'GET_USER_ERROR'

export const SET_APPOINTMENT_COSTUMER_DETAILS = 'SET_APPOINTMENT_COSTUMER_DETAILS'

export const INITIALIZE_APPOINTMENT_STORE = 'INITIALIZE_APPOINTMENT_STORE'

export const SET_WITH_OBJECT_CLEANING = 'SET_WITH_OBJECT_CLEANING'

export const CAPTURE_CURRENT_RECORD_DATA = 'CAPTURE_CURRENT_RECORD_DATA'
export const CAPTURE_ADDITIONAL_RECORD_DATA = 'CAPTURE_ADDITIONAL_RECORD_DATA'
export const CLEAN_CAPTURED_RECORD_DATA = 'CLEAN_CAPTURED_RECORD_DATA'

export const SET_SIGNATURE_GENERATION_PROCESS = 'SET_SIGNATURE_GENERATION_PROCESS'
export const GET_SELECT_RESOURCE_SIGNATURE_GENERATION_PROCESS = 'GET_SELECT_RESOURCE_SIGNATURE_GENERATION_PROCESS'

export const SAVE_2_STEP_TOKEN = 'SAVE_2_STEP_TOKEN'

export const IS_AUTHENTICATED_START = 'IS_AUTHENTICATED_START'
export const IS_AUTHENTICATED_SUCCESS = 'IS_AUTHENTICATED_SUCCESS'
export const IS_AUTHENTICATED_ERROR = 'IS_AUTHENTICATED_ERROR'

export const GET_SEEKER_START = 'GET_SEEKER_START'
export const GET_SEEKER_SUCCESS = 'GET_SEEKER_SUCCESS'
export const GET_SEEKER_ERROR = 'GET_SEEKER_ERROR'

export const GET_NOTIFICATIONS_START = 'GET_NOTIFICATIONS_START'
export const GET_NOTIFICATIONS_SUCCESS = 'GET_NOTIFICATIONS_SUCCESS'
export const GET_NOTIFICATIONS_ERROR = 'GET_NOTIFICATIONS_ERROR'

export const GET_EVENT = 'GET_EVENT'

export const GET_STATE_ROUTE = 'GET_STATE_ROUTE'
export const SET_STATE_ROUTE = 'SET_STATE_ROUTE'

export const GET_STATUS_COSTUMER_PAYMENTS_START = 'GET_STATUS_COSTUMER_PAYMENTS_START'
export const GET_STATUS_COSTUMER_PAYMENTS_SUCCESS = 'GET_STATUS_COSTUMER_PAYMENTS_SUCCESS'
export const GET_STATUS_COSTUMER_PAYMENTS_ERROR = 'GET_STATUS_COSTUMER_PAYMENTS_ERROR'

export const GET_MODEL_COMMENTS_START = 'GET_MODEL_COMMENTS_START'
export const GET_MODEL_COMMENTS_SUCCESS = 'GET_MODEL_COMMENTS_SUCCESS'
export const GET_MODEL_COMMENTS_ERROR = 'GET_MODEL_COMMENTS_ERROR'

export const GET_PRIORITIES_ENTRY_START = 'GET_PRIORITIES_ENTRY_START'
export const GET_PRIORITIES_ENTRY_SUCCESS = 'GET_PRIORITIES_ENTRY_SUCCESS'
export const GET_PRIORITIES_ENTRY_ERROR = 'GET_PRIORITIES_ENTRY_ERROR'

export const GET_DEPARTMENTS_ENTRY_START = 'GET_DEPARTMENTS_ENTRY_START'
export const GET_DEPARTMENTS_ENTRY_SUCCESS = 'GET_DEPARTMENTS_ENTRY_SUCCESS'
export const GET_DEPARTMENTS_ENTRY_ERROR = 'GET_DEPARTMENTS_ENTRY_ERROR'

export const GET_STATUS_ENTRY_START = 'GET_STATUS_ENTRY_START'
export const GET_STATUS_ENTRY_SUCCESS = 'GET_STATUS_ENTRY_SUCCESS'
export const GET_STATUS_ENTRY_ERROR = 'GET_STATUS_ENTRY_ERROR'

export const GET_STATUS_WRITING_START = 'GET_STATUS_WRITING_START'
export const GET_STATUS_WRITING_SUCCESS = 'GET_STATUS_WRITING_SUCCESS'
export const GET_STATUS_WRITING_ERROR = 'GET_STATUS_WRITING_ERROR'

export const GET_ROOMS_START = 'GET_ROOMS_START'
export const GET_ROOMS_SUCCESS = 'GET_ROOMS_SUCCESS'
export const GET_ROOMS_ERROR = 'GET_ROOMS_ERROR'

export const GET_ROOM_MESSAGES_START = 'GET_ROOM_MESSAGES_START'
export const GET_ROOM_MESSAGES_SUCCESS = 'GET_ROOM_MESSAGES_SUCCESS'
export const GET_ROOM_MESSAGES_ERROR = 'GET_ROOM_MESSAGES_ERROR'

export const GET_ADD_ROOM_MESSAGES_START = 'GET_ADD_ROOM_MESSAGES_START'
export const GET_ADD_ROOM_MESSAGES_SUCCESS = 'GET_ADD_ROOM_MESSAGES_SUCCESS'
export const GET_ADD_ROOM_MESSAGES_ERROR = 'GET_ADD_ROOM_MESSAGES_ERROR'

export const GET_UPDATE_STATUS_TO_SEEN_START = 'GET_UPDATE_STATUS_TO_SEEN_START'
export const GET_UPDATE_STATUS_TO_SEEN_SUCCESS = 'GET_UPDATE_STATUS_TO_SEEN_SUCCESS'
export const GET_UPDATE_STATUS_TO_SEEN_ERROR = 'GET_UPDATE_STATUS_TO_SEEN_ERROR'

export const STORE_ROOM_START = 'STORE_ROOM_START'
export const STORE_ROOM_SUCCESS = 'STORE_ROOM_SUCCESS'
export const STORE_ROOM_ERROR = 'STORE_ROOM_ERROR'

export const UPDATE_REACTION_START = 'UPDATE_REACTION_START'
export const UPDATE_REACTION_SUCCESS = 'UPDATE_REACTION_SUCCESS'
export const UPDATE_REACTION_ERROR = 'UPDATE_REACTION_ERROR'

export const SET_MODULE_INDICATOR_START = 'SET_MODULE_INDICATOR_START'
export const SET_MODULE_INDICATOR_SUCCESS = 'SET_MODULE_INDICATOR_SUCCESS'

export const GET_USER_SETTINGS_START = 'GET_USER_SETTINGS_START'
export const GET_USER_SETTINGS_SUCCESS = 'GET_USER_SETTINGS_SUCCESS'
export const GET_USER_SETTINGS_ERROR = 'GET_USER_SETTINGS_ERROR'

export const SET_USER_SETTINGS_START = 'SET_USER_SETTINGS_START'
export const SET_USER_SETTINGS_SUCCESS = 'SET_USER_SETTINGS_SUCCESS'
export const SET_USER_SETTINGS_ERROR = 'SET_USER_SETTINGS_ERROR'

export const GET_ASSIGNMENT_TYPES_START = 'GET_ASSIGNMENT_TYPES_START'
export const GET_ASSIGNMENT_TYPES_SUCCESS = 'GET_ASSIGNMENT_TYPES_SUCCESS'
export const GET_ASSIGNMENT_TYPES_ERROR = 'GET_ASSIGNMENT_TYPES_ERROR'

export const GET_SALES_COMPLETE_BANK_APPLICATION_STATUS_START = 'GET_SALES_COMPLETE_BANK_APPLICATION_STATUS_START'
export const GET_SALES_COMPLETE_BANK_APPLICATION_STATUS_SUCCESS = 'GET_SALES_COMPLETE_BANK_APPLICATION_STATUS_SUCCESS'
export const GET_SALES_COMPLETE_BANK_APPLICATION_STATUS_ERROR = 'GET_SALES_COMPLETE_BANK_APPLICATION_STATUS_ERROR'

export const GET_COMPLETE_SALES_STATES_PRECONTRACT_START = 'GET_COMPLETE_SALES_STATES_PRECONTRACT_START'
export const GET_COMPLETE_SALES_STATES_PRECONTRACT_SUCCESS = 'GET_COMPLETE_SALES_STATES_PRECONTRACT_SUCCESS'
export const GET_COMPLETE_SALES_STATES_PRECONTRACT_ERROR = 'GET_COMPLETE_SALES_STATES_PRECONTRACT_ERROR'

export const GET_SALES_BANK_APPLICATION_STATUS_BY_NAME_ID_START = 'GET_SALES_BANK_APPLICATION_STATUS_BY_NAME_ID_START'
export const GET_SALES_BANK_APPLICATION_STATUS_BY_NAME_ID_SUCCESS = 'GET_SALES_BANK_APPLICATION_STATUS_BY_NAME_ID_SUCCESS'
export const GET_SALES_BANK_APPLICATION_STATUS_BY_NAME_ID_ERROR = 'GET_SALES_BANK_APPLICATION_STATUS_BY_NAME_ID_ERROR'

export const GET_SALES_DOCUMENT_STATUS_BY_NAME_ID_START = 'GET_SALES_DOCUMENT_STATUS_BY_NAME_ID_START'
export const GET_SALES_DOCUMENT_STATUS_BY_NAME_ID_SUCCESS = 'GET_SALES_DOCUMENT_STATUS_BY_NAME_ID_SUCCESS'
export const GET_SALES_DOCUMENT_STATUS_BY_NAME_ID_ERROR = 'GET_SALES_DOCUMENT_STATUS_BY_NAME_ID_ERROR'

export const GET_LAWYERS_START = 'GET_LAWYERS_START'
export const GET_LAWYERS_SUCCESS = 'GET_LAWYERS_SUCCESS'
export const GET_LAWYERS_ERROR = 'GET_LAWYERS_ERROR'

export const GET_LAWYERS_USER_START = 'GET_LAWYERS_USER_START'
export const GET_LAWYERS_USER_SUCCESS = 'GET_LAWYERS_USER_SUCCESS'
export const GET_LAWYERS_USER_ERROR = 'GET_LAWYERS_USER_ERROR'

export const GET_ROOMS_MESSAGES_START = 'GET_ROOMS_MESSAGES_START'
export const GET_ROOMS_MESSAGES_SUCCESS = 'GET_ROOMS_MESSAGES_SUCCESS'
export const GET_ROOMS_MESSAGES_ERROR = 'GET_ROOMS_MESSAGES_ERROR'

export const GET_ROOM_ACTIVE_MESSAGES_START = 'GET_ROOM_ACTIVE_MESSAGES_START'
export const GET_ROOM_ACTIVE_MESSAGES_SUCCESS = 'GET_ROOM_ACTIVE_MESSAGES_SUCCESS'
export const GET_ROOM_ACTIVE_MESSAGES_ERROR = 'GET_ROOM_ACTIVE_MESSAGES_ERROR'

export const GET_ROOM_ACTIVE_START = 'GET_ROOM_ACTIVE_START'
export const GET_ROOM_ACTIVE_SUCCESS = 'GET_ROOM_ACTIVE_SUCCESS'
export const GET_ROOM_ACTIVE_ERROR = 'GET_ROOM_ACTIVE_ERROR'

export const SET_NOTIFY_ROOM_CHANGE_START = 'SET_NOTIFY_ROOM_CHANGE_START'
export const SET_NOTIFY_ROOM_CHANGE_SUCCESS = 'SET_NOTIFY_ROOM_CHANGE_SUCCESS'
export const SET_NOTIFY_ROOM_CHANGE_ERROR = 'SET_NOTIFY_ROOM_CHANGE_ERROR'

export const REGISTER_SUBSCRIPTION_CONVERSATION_START = 'REGISTER_SUBSCRIPTION_CONVERSATION_START'
export const REGISTER_SUBSCRIPTION_CONVERSATION_SUCCESS = 'REGISTER_SUBSCRIPTION_CONVERSATION_SUCCESS'
export const REGISTER_SUBSCRIPTION_CONVERSATION_ERROR = 'REGISTER_SUBSCRIPTION_CONVERSATION_ERROR'

export const GET_ROOM_START = 'GET_ROOM_START'
export const GET_ROOM_SUCCESS = 'GET_ROOM_SUCCESS'
export const GET_ROOM_ERROR = 'GET_ROOM_ERROR'

export const SET_FILE_MESSAGE_ACTIVE_START = 'SET_FILE_MESSAGE_ACTIVE_START'
export const SET_FILE_MESSAGE_ACTIVE_SUCCESS = 'SET_FILE_MESSAGE_ACTIVE_SUCCESS'
export const SET_FILE_MESSAGE_ACTIVE_ERROR = 'SET_FILE_MESSAGE_ACTIVE_ERROR'

export const CHANGE_STATUS_TO_READ_BY_THE_PROCESSOR_START = 'CHANGE_STATUS_TO_READ_BY_THE_PROCESSOR_START'
export const CHANGE_STATUS_TO_READ_BY_THE_PROCESSOR_SUCCESS = 'CHANGE_STATUS_TO_READ_BY_THE_PROCESSOR_SUCCESS'
export const CHANGE_STATUS_TO_READ_BY_THE_PROCESSOR_ERROR = 'CHANGE_STATUS_TO_READ_BY_THE_PROCESSOR_ERROR'

export const GET_ROOM_HISTORY_START = 'GET_ROOM_HISTORY_START'
export const GET_ROOM_HISTORY_SUCCESS = 'GET_ROOM_HISTORY_SUCCESS'
export const GET_ROOM_HISTORY_ERROR = 'GET_ROOM_HISTORY_ERROR'

export const GET_LAST_CUSTOMER_ACTIONS_START = 'GET_LAST_CUSTOMER_ACTIONS_START'
export const GET_LAST_CUSTOMER_ACTIONS_SUCCESS = 'GET_LAST_CUSTOMER_ACTIONS_SUCCESS'
export const GET_LAST_CUSTOMER_ACTIONS_ERROR = 'GET_LAST_CUSTOMER_ACTIONS_ERROR'

export const GET_ADDENDUM_STATUS_START = 'GET_ADDENDUM_STATUS_START'
export const GET_ADDENDUM_STATUS_SUCCESS = 'GET_ADDENDUM_STATUS_SUCCESS'
export const GET_ADDENDUM_STATUS_ERROR = 'GET_ADDENDUM_STATUS_ERROR'
